import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";

const formSchema = z.object({
  qa_comment: z.string().optional(),
  qa_issue: stringSchema({ key: "Issue selection", required: true }),
  files: z.array(z.any()),
})

export default formSchema;